import React, { useState } from "react";
import "./languageSwitch.css";

import egyptFlag from "../../../assets/telawah-assets/egyptFlag.png";
import britishFlag from "../../../assets/telawah-assets/britsh.png";
import germanFlag from "../../../assets/telawah-assets/germanFlag.png";

import { useLanguage } from "../../../context/LanguageContext";

const LanguageSwitch = ({ className }) => {
    const { language, switchLanguage } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleLanguageChange = (lang) => {
        switchLanguage(lang);
        setIsOpen(false);
        document.body.style.direction = lang === "ar" ? "rtl" : "ltr";
        document.body.style.textAlign = lang === "ar" ? "right" : "left";
        document.body.style.fontFamily = lang === "de" ? "Arial, sans-serif" : "var(--font-family)";
    };

    const getFlag = (lang) => {
        switch (lang) {
            case "en":
                return britishFlag;
            case "ar":
                return egyptFlag;
            case "de":
                return germanFlag;
            default:
                return egyptFlag;
        }
    };

    const getLanguageLabel = (lang) => {
        switch (lang) {
            case "en":
                return "English";
            case "ar":
                return "العربية";
            case "de":
                return "Deutsch";
            default:
                return "العربية";
        }
    };

    return (
        <div className={className}>
            <div className="language-switch px-4">
                {/* Selected Language */}
                <div
                    className="selected-language"
                    onClick={toggleDropdown}
                    onMouseEnter={() => setIsOpen(true)}
                >
                    <img
                        src={getFlag(language)}
                        alt={getLanguageLabel(language)}
                        className="flag-icon"
                    />
                    <span>{getLanguageLabel(language)}</span>
                </div>

                {/* Language Dropdown */}
                {isOpen && (
                    <div className="language-dropdown" onMouseEnter={() => setIsOpen(true)}>
                        <div className="language-option" onClick={() => handleLanguageChange("en")}>
                            <img src={britishFlag} alt="English" className="flag-icon" />
                            English
                        </div>
                        <div className="language-option" onClick={() => handleLanguageChange("ar")}>
                            <img src={egyptFlag} alt="العربية" className="flag-icon" />
                            العربية
                        </div>
                        <div className="language-option" onClick={() => handleLanguageChange("de")}>
                            <img src={germanFlag} alt="Deutsch" className="flag-icon" />
                            Deutsch
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LanguageSwitch;
